import ReactSlick from 'react-slick';

// In some bundling/runtime combinations, react-slick can be exposed as a module object.
// Normalize it to the actual React component before rendering.
const SlickSlider = ReactSlick?.default ?? ReactSlick;

export default SlickSlider;
